import { render, staticRenderFns } from "./OrderStoryTable.vue?vue&type=template&id=069b99bc"
import script from "./OrderStoryTable.vue?vue&type=script&lang=js"
export * from "./OrderStoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports